import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* createPromotion({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.promotions.create, data: values });

    onSuccess && onSuccess();
    yield put(actions.createPromotionDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createPromotionFailed,
      handledErrors,
      endpoint: api.promotions.create.url
    });
  }
}

export const createPromotionSaga = takeEvery(types.CREATE_PROMOTION_REQUEST, createPromotion);